import styled from "styled-components";
import { createGlobalStyle } from 'styled-components';

export const HeroContainer = styled.div`
  background: ${({ theme }) => theme.card_light};
  display: flex;
  justify-content: center;
  position: relative;
  padding: 80px 30px;
  @media (max-width: 960px) {
    padding: 66px 16px;
  }
  @media (max-width: 640) {
    padding: 32px 16px;
  }
  z-index: 1;

  clip-path: polygon(0 0, 100% 0, 100% 100%, 70% 95%, 0 100%);
`;

export const HeroBg = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 1360px;
  overflow: hidden;
  padding: 0 30px;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);

  @media (max-width: 960px) {
    justify-content: center;
    padding: 0 0px;
  }
`;

export const HeroInnerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1100px;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
export const HeroLeftContainer = styled.div`
  width: 100%;
  order: 1;
  background: rgba(30, 30, 60, 0.55);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37), 0 1.5px 24px 0 ${({ theme }) => theme.primary + '22'};
  backdrop-filter: blur(12px) saturate(180%);
  border-radius: 40px;
  padding: 40px 32px;
  border: 1.5px solid ${({ theme }) => theme.primary + '33'};
  animation: fadeInLeft 1.2s cubic-bezier(0.23, 1, 0.32, 1);
  @media (max-width: 960px) {
    order: 2;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px 12px;
  }
  @media (max-width: 640px) {
    order: 2;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 18px 6px;
  }
`;

export const HeroRightContainer = styled.div`
  width: 100%;
  display: flex;
  order: 2;
  justify-content: end;
  gap: 12px;
  @media (max-width: 960px) {
    order: 1;
    justify-content: center;
    align-items: center;
    margin-bottom: 80px;
  }

  @media (max-width: 640px) {
    margin-bottom: 30px;
  }
`;

export const Img = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 420px;
  max-height: 420px;
  object-fit: cover;
  border-radius: 50%;
  border: 3px solid ${({ theme }) => theme.primary};
  box-shadow: 0 0 48px 12px ${({ theme }) => theme.primary + '66'}, 0 0 0 12px ${({ theme }) => theme.card_light + '22'};
  filter: drop-shadow(0 0 32px ${({ theme }) => theme.primary + '99'});
  animation: fadeInRight 1.2s cubic-bezier(0.23, 1, 0.32, 1);
  transition: box-shadow 0.3s, transform 0.3s;
  &:hover {
    box-shadow: 0 0 64px 24px ${({ theme }) => theme.primary + '99'};
    transform: scale(1.04) rotate(-2deg);
  }
  @media (max-width: 768px) {
    max-width: 340px;
    max-height: 340px;
  }

  @media (max-width: 640px) {
    max-width: 220px;
    max-height: 220px;
  }
`;

export const Title = styled.div`
  font-weight: 800;
  font-size: 42px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 56px;
  letter-spacing: 2px;
  text-shadow: 0 2px 24px ${({ theme }) => theme.primary + '44'};
  animation: fadeInUp 1.2s cubic-bezier(0.23, 1, 0.32, 1);
  @media (max-width: 960px) {
    text-align: center;
    font-size: 36px;
    line-height: 44px;
  }
  @media (max-width: 640px) {
    font-size: 28px;
    line-height: 36px;
    margin-bottom: 8px;
  }
`;

export const TextLoop = styled.div`
  font-weight: 700;
  font-size: 36px;
  display: flex;
  gap: 12px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 68px;
  margin-bottom: 12px;
  animation: fadeInUp 1.6s cubic-bezier(0.23, 1, 0.32, 1);
  @media (max-width: 960px) {
    text-align: center;
  }
  @media (max-width: 640px) {
    font-size: 24px;
    line-height: 48px;
    margin-bottom: 16px;
  }
`;

export const Span = styled.span`
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  font-weight: 800;
  text-shadow: 0 2px 12px ${({ theme }) => theme.primary + '44'};
`;

export const SubTitle = styled.div`
  font-size: 22px;
  line-height: 36px;
  margin-bottom: 48px;
  color: ${({ theme }) => theme.text_secondary};
  animation: fadeInUp 2s cubic-bezier(0.23, 1, 0.32, 1);
  font-weight: 500;
  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 16px;
    line-height: 32px;
  }
`;

export const ResumeButton = styled.a`
    -webkit-appearance: button;
    -moz-appearance: button;
    appearance: button;
    text-decoration: none;
    width: 95%;
    max-width: 320px;
    text-align: center;
    padding: 18px 0;
    color:${({ theme }) => theme.white};
    border-radius: 24px;
    cursor: pointer;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 1px;
    transition: all 0.2s ease-in-out !important;
    background: linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
    border: 2.5px solid ${({ theme }) => theme.primary};
    box-shadow:  0 4px 32px ${({ theme }) => theme.primary + '44'};
    position: relative;
    z-index: 2;
    overflow: hidden;
    &:after {
      content: '';
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      background: linear-gradient(90deg, ${({ theme }) => theme.primary + '33'}, transparent);
      opacity: 0.2;
      z-index: 1;
      border-radius: 24px;
    }
    &:hover {
        transform: scale(1.09);
        filter: brightness(1.18);
        box-shadow: 0 8px 48px ${({ theme }) => theme.primary + '99'};
        background: linear-gradient(90deg, hsla(294, 100%, 50%, 1) 0%, hsla(271, 100%, 50%, 1) 100%);
    }    
    @media (max-width: 640px) {
        padding: 12px 0;
        font-size: 18px;
    } 
`;

// Animations
export const fadeInKeyframes = `
@keyframes fadeInLeft {
  0% { opacity: 0; transform: translateX(-60px); }
  100% { opacity: 1; transform: translateX(0); }
}
@keyframes fadeInRight {
  0% { opacity: 0; transform: translateX(60px); }
  100% { opacity: 1; transform: translateX(0); }
}
@keyframes fadeInUp {
  0% { opacity: 0; transform: translateY(40px); }
  100% { opacity: 1; transform: translateY(0); }
}
`;

// Inject keyframes into global style
export const GlobalHeroAnimations = createGlobalStyle`
  ${fadeInKeyframes}
`;
